<template>
  <div class="legend">
    <p class="legend__title">{{ title }}:</p>
    <div class="legend__container">
      <div class="legend__bar"></div>
      <div class="legend__items">
        <div class="legend__value">
          <div class="legend__icon">
            <PositiveIcon />
          </div>
          <span>{{ $t("message.sentiment.positive") }}</span>
        </div>
        <div class="legend__value">
          <div class="legend__icon">
            <NeutralIcon />
          </div>

          <span>{{ $t("message.sentiment.mixed") }}</span>
        </div>
        <div class="legend__value">
          <div class="legend__icon">
            <NegativeIcon />
          </div>
          <span>{{ $t("message.sentiment.negative") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PositiveIcon from "@/components/ui/Icons/sentiment/PositiveIcon.vue";
import NegativeIcon from "@/components/ui/Icons/sentiment/NegativeIcon.vue";
import NeutralIcon from "@/components/ui/Icons/sentiment/NeutralIcon.vue";
export default {
  name: "ReviewsCategoriesLegend",
  components: {
    PositiveIcon,
    NegativeIcon,
    NeutralIcon
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
$legend-green: #29c15b;
$legend-green-2: #c5d727;
$legend-mixed: #dbda1f;
$legend-yellow: #e5ad35;
$legend-red: #ff316e;
.legend {
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 1300px;
  width: 100%;

  &__icon {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    position: relative;
    z-index: 1;

    &:after {
      inset: 0;
      margin: auto;
      content: "";
      display: block;
      width: 20px;
      height: 20px;
      background: white;
      border-radius: 50%;
      position: absolute;
      z-index: -1;
    }
  }

  &__bar {
    border-radius: 8px;
    background: linear-gradient(
      90deg,
      $legend-green 0%,
      $legend-green-2 45%,
      $legend-mixed 49%,
      $legend-mixed 51%,
      $legend-yellow 55%,
      $legend-red 100%
    );
    height: 10px;
  }

  &__title {
    font-weight: 600;
  }

  &__items {
    display: flex;
    margin-top: $spacing;
    justify-content: space-between;
    font-weight: 600;
    width: 100%;
    top: -25px;
    position: relative;
  }

  &__el {
    width: 100%;
    height: 20px;
    flex-shrink: 1;
  }

  &__value {
    display: flex;
    flex-shrink: 1;
    flex-direction: column;

    span {
      line-height: 1rem;
      margin-top: $spacing;
    }

    &:nth-child(2) {
      align-items: center;
    }

    &:last-child {
      align-items: flex-end;
    }
  }
}
</style>
